import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const B2BBusinessCategories = () => {
  const b2bCategories = [
  {
    id: 1,
    icon: 'Headphones',
    iconColor: 'text-blue-600',
    bgColor: 'bg-blue-50',
    title: 'BPO Services',
    description: 'Comprehensive Business Process Outsourcing solutions to streamline your operations and reduce overhead costs.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14a8a7de7-1772850166420.png",
    imageAlt: 'BPO Services team working in modern office with headsets',
    features: [
    'Data Entry & Processing',
    'Call Center Operations',
    'Back Office Support',
    'Customer Service']

  },
  {
    id: 2,
    icon: 'Building2',
    iconColor: 'text-teal-600',
    bgColor: 'bg-teal-50',
    title: 'Facility Management',
    description: 'End-to-end facility management and maintenance services for housekeeping, security, maintenance and administrative support.',
    image: "https://images.unsplash.com/photo-1656646425073-a1ec4a84e0dc",
    imageAlt: 'Modern office facility with professional management',
    features: [
    'Housekeeping Services',
    'Security Services',
    'Administrative Support',
    'Vendor Management']

  },
  {
    id: 3,
    icon: 'Users',
    iconColor: 'text-purple-600',
    bgColor: 'bg-purple-50',
    title: 'Resource Augmentation',
    description: 'Scale your workforce with trained professionals across various domains without long-term commitments.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d2e3f5fa-1768500410921.png",
    imageAlt: 'Professional team collaborating on business project',
    features: [
    'Skilled Manpower',
    'Technical Support',
    'Specialized Staff',
    'Temporary Staff']

  },
  {
    id: 4,
    icon: 'Truck',
    iconColor: 'text-orange-600',
    bgColor: 'bg-orange-50',
    title: 'Logistics & Last Mile',
    description: 'End-to-end logistics solutions and office relocation services for seamless operations across all locations.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_179c39bc5-1772300939322.png",
    imageAlt: 'Logistics delivery truck and warehouse operations',
    features: [
    'Logistics Management',
    'Transportation',
    'Warehousing Solutions',
    'Office Relocation']

  },
  {
    id: 5,
    icon: 'AlertCircle',
    iconColor: 'text-red-600',
    bgColor: 'bg-red-50',
    title: 'Incident Event Management',
    description: 'Professional event management models for corporate events, conferences, exhibitions, and business launches.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_106fd65b4-1770192319978.png",
    imageAlt: 'Corporate event management and conference setup',
    features: [
    'Corporate Events',
    'Conference Management',
    'Exhibition Support',
    'Product Launches']

  },
  {
    id: 6,
    icon: 'Wrench',
    iconColor: 'text-green-600',
    bgColor: 'bg-green-50',
    title: 'Maintenance Services',
    description: 'Preventive and corrective maintenance services for all equipment, machinery, and infrastructure.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1987c125c-1772840540968.png",
    imageAlt: 'Maintenance technician servicing industrial equipment',
    features: [
    'Equipment Servicing',
    'Infrastructure Support',
    'Preventive Maintenance',
    'Emergency Repairs']

  },
  {
    id: 7,
    icon: 'Monitor',
    iconColor: 'text-indigo-600',
    bgColor: 'bg-indigo-50',
    title: 'Centralized Monitoring',
    description: 'Centralized monitoring and control systems to ensure optimal operations across all business locations.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_167177837-1770192319285.png",
    imageAlt: 'Centralized monitoring dashboard with analytics',
    features: [
    'Operations Monitoring',
    'Performance Tracking',
    'Real-time Alerts',
    'Data Analytics']

  },
  {
    id: 8,
    icon: 'Zap',
    iconColor: 'text-yellow-600',
    bgColor: 'bg-yellow-50',
    title: 'Energy Management',
    description: 'Optimize energy consumption and reduce operational costs with sustainable solutions and energy audits.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_124cf0b54-1773386592807.png",
    imageAlt: 'Energy management solar panels and sustainable solutions',
    features: [
    'Energy Audits',
    'Cost Optimization',
    'Sustainable Solutions',
    'Utility Management']

  },
  {
    id: 9,
    icon: 'ShieldCheck',
    iconColor: 'text-cyan-600',
    bgColor: 'bg-cyan-50',
    title: 'Compliance & Safety',
    description: 'Ensure consistent compliance and safety standards across all facilities with regulatory support and training programs.',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_14433a775-1772241860081.png",
    imageAlt: 'Compliance and safety professional reviewing documents',
    features: [
    'Safety Protocols',
    'Regulatory Compliance',
    'Risk Assessment',
    'Training Programs']

  }];


  return (
    <section className="py-12 md:py-16 lg:py-20 px-4 md:px-6 lg:px-8 bg-gradient-to-br from-blue-50 via-white to-teal-50">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-primary/10 rounded-full mb-4">
            <Icon name="Globe" size={20} className="text-primary" />
            <span className="text-sm font-semibold text-primary">Comprehensive B2B Solutions</span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">
            Business Category Attracting Indian Customers & Local Support
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            From BPO services to facility management and resource augmentation, we provide end-to-end solutions that help your business focus on growth while we handle operations.
          </p>
        </div>

        {/* B2B Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {b2bCategories?.map((category) =>
          <div
            key={category?.id}
            className="group bg-card rounded-xl overflow-hidden border border-border hover:shadow-xl transition-all duration-300 cursor-pointer">

              {/* Category Image */}
              <div className="relative h-48 overflow-hidden">
                <Image
                src={category?.image}
                alt={category?.imageAlt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
                <div className="absolute bottom-4 left-4 flex items-center gap-3">
                  <div className={`w-12 h-12 rounded-lg ${category?.bgColor} flex items-center justify-center backdrop-blur-sm`}>
                    <Icon name={category?.icon} size={24} className={category?.iconColor} />
                  </div>
                  <h3 className="text-lg font-bold text-white">{category?.title}</h3>
                </div>
              </div>

              {/* Category Content */}
              <div className="p-6">
                <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
                  {category?.description}
                </p>

                {/* Features List */}
                <ul className="space-y-2 mb-4">
                  {category?.features?.map((feature, index) =>
                <li key={index} className="flex items-center gap-2 text-sm text-foreground">
                      <Icon name="CheckCircle2" size={16} className="text-success flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                )}
                </ul>

                {/* CTA Button */}
                <button className="w-full px-4 py-2.5 bg-primary text-primary-foreground rounded-lg font-medium hover:bg-primary/90 transition-colors flex items-center justify-center gap-2 group-hover:gap-3">
                  <span>Learn More</span>
                  <Icon name="ArrowRight" size={18} />
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Bottom CTA */}
        <div className="mt-12 md:mt-16 text-center">
          <div className="bg-card rounded-2xl p-8 md:p-10 border border-border shadow-lg">
            <div className="flex items-center justify-center gap-2 mb-4">
              <Icon name="MapPin" size={24} className="text-primary" />
              <span className="text-lg font-semibold text-primary">🇮🇳 Pan-India Coverage with Local Support</span>
            </div>
            <h3 className="text-xl md:text-2xl font-bold text-foreground mb-3">
              Ready to Transform Your Business Operations?
            </h3>
            <p className="text-base text-muted-foreground mb-6 max-w-2xl mx-auto">
              Connect with verified Indian service providers offering local support across all major cities. Get customized solutions tailored to your business needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center">
              <button className="px-6 md:px-8 py-3 md:py-4 bg-primary text-primary-foreground rounded-lg md:rounded-xl font-semibold hover:bg-primary/90 transition-colors text-sm md:text-base flex items-center justify-center gap-2">
                <Icon name="Phone" size={20} />
                <span>Request Consultation</span>
              </button>
              <button className="px-6 md:px-8 py-3 md:py-4 bg-transparent border-2 border-primary text-primary rounded-lg md:rounded-xl font-semibold hover:bg-primary/5 transition-colors text-sm md:text-base flex items-center justify-center gap-2">
                <Icon name="FileText" size={20} />
                <span>Download Brochure</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default B2BBusinessCategories;